/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {ResponseData, showDialog} from '@dvrd/dvr-controls';
import React, {PureComponent} from 'react';
import SubscriptionStats from "../../../models/subscriptionStatsModel";
import {DataSplitMethod} from '../../../util/interfaces';
import SubscriptionStatsTable from "./subscriptionStatsTable";

const LIMIT = 20;

interface State {
    active: boolean;
    loading: boolean;
    stats: Array<SubscriptionStats>;
    total: number;
    page: number;
    splitMethod: DataSplitMethod;
}

export default class SubscriptionStatsController extends PureComponent<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            active: false, loading: false, page: 0, stats: [], total: 0, splitMethod: DataSplitMethod.WEEK
        }
    }

    activate = () => {
        this.setState({active: true}, this.load);
    }

    onClose = () => {
        this.setState({active: false});
    }

    onChangePage = (nextPage: number) => () => {
        this.setState({page: nextPage}, this.load);
    };

    onChangeSplitMethod = (splitMethod: DataSplitMethod) => {
        this.setState({splitMethod}, this.load);
    };

    load = () => {
        this.setState({loading: true});
        const {page, splitMethod} = this.state;
        SubscriptionStats.getAll(page, LIMIT, splitMethod, undefined, undefined,
            (stats: SubscriptionStats[], success: boolean, data: ResponseData) => {
                this.setState({loading: false});
                if (success) {
                    stats.forEach((stat: SubscriptionStats, index: number) => {
                        if (index < stats.length - 1) stat.calculateGain(stats[index + 1]);
                    })
                    this.setState({total: data.total, stats});
                } else showDialog(data.message ?? 'Het laden van de statistieken is niet gelukt.', 'Laden mislukt');
            });
    }

    render = () => {
        const {page, total, stats, loading, active, splitMethod} = this.state;
        return (
            <SubscriptionStatsTable onClose={this.onClose} onChangePage={this.onChangePage}
                                    onChangeSplitMethod={this.onChangeSplitMethod} stats={stats} loading={loading}
                                    active={active} page={page} total={total} splitMethod={splitMethod}/>
        )
    }
}